import React from 'react';

/**
 * MisReportDescription component
 * 
 * This component provides a description and instructions for the Management Information System (MIS) report used by employers subject to DOT or USCG regulations.
 * It includes instructions for selecting a location, DOT number, and year, as well as links to agency resources and downloadable forms.
 * @returns {JSX.Element} The rendered MisReportDescription component.
 */
export const MisReportDescription = () => (
  <>
    <p>
      The Management Information Systems (MIS) report is used by employers subject to Department of Transportation (DOT) or U.S. Coast Guard (USCG) regulations to submit required annual drug and alcohol testing data.
    </p>
    <p>
      <strong>Instructions:</strong>
    </p>
    <ol>
      <li>Select a location to view the DOT numbers available for that location and its child locations.</li>
      <li>Select a DOT number from the list provided.</li>
      <li>Select a year for which you want to view MIS data.</li>
      <li>Select a testing authority for the selected DOT number.</li>
    </ol>
    <p>
      <strong>You may download a blank version of the report or export your data to Excel using the buttons below.</strong>
    </p>
    <p>
      <strong>Agency Resources:</strong>
    </p>
    <ul style={{ listStyle: 'none', paddingLeft: 0, marginBottom: 0 }}>
      <li>
        <a href="https://www.faa.gov/about/office_org/headquarters_offices/avs/offices/aam/drug_alcohol/regulations/mis" target="_blank" rel="noopener noreferrer">FAA Instructions</a>
      </li>
      <li>
        <a href="https://railroads.dot.gov/elibrary/drug-and-alcohol-management-information-system-damis-internet-reporting-user-manual" target="_blank" rel="noopener noreferrer">FRA Instructions</a>
      </li>
      <li>
        <a href="https://transit-safety.fta.dot.gov/DrugAndAlcohol/DAMIS/default.aspx" target="_blank" rel="noopener noreferrer">FTA Instructions</a>
      </li>
      <li>
        <a href="https://www.phmsa.dot.gov/pipeline/drug-and-alcohol/mis-reporting" target="_blank" rel="noopener noreferrer">PHMSA Instructions</a>
      </li>
    </ul>
    <ul style={{ listStyle: 'none', paddingLeft: 0, marginTop: 8 }}>
      <li>
        <a href="https://www.transportation.gov/odapc/MISreporting" target="_blank" rel="noopener noreferrer">MIS Reports Overview</a>
      </li>
      <li>
        <a href="https://www.transportation.gov/sites/dot.gov/files/2023-02/Appdx_H_20230223_MIS_Instructions.pdf" target="_blank" rel="noopener noreferrer">MIS Form Instructions (PDF)</a>
      </li>
    </ul>
  </>
);